import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { FaPlus, FaFileAlt, FaLink } from "react-icons/fa";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormGroup,
  Label,
  Table,
} from "reactstrap";
import Adminnavbar from "../Components/Adminnavbar";
import { useDataContext } from "../Context/dataContext";
import { NotFound } from "./NotFound";

function GestionUsuarios() {
  const { url, infoTkn } = useDataContext();
  const [busqueda, setBusqueda] = useState("");
  // const [paginaActual, setPaginaActual] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [use_name, setNombre] = useState("");
  const [use_lastName, setApellido] = useState("");
  const [use_email, setCorreo] = useState("");
  const [modalOpen2, setModalOpen2] = useState(false); // Estado para controlar el modal
  const [selectedUser, setSelectedUser] = useState(null); // Estado para el usuario seleccionado
  // const [generatedLink, setGeneratedLink] = useState(""); // Estado para almacenar el link generado
  const [userDetailsModalOpen, setUserDetailsModalOpen] = useState(false);
  const [editUserModalOpen, setEditUserModalOpen] = useState(false);
  const [userMovementsModalOpen, setUserMovementsModalOpen] = useState(false);

  const apiKey = "b50eb96202f539479e288ab6547ea9484003";

  const [admin, setAdmin] = useState({});
  const [users, setUsers] = useState([]);

  const [ordersByUser, setOrdersByUser] = useState([]);

  const fetchDataAdmin = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/Auth/findByJWTAdmin/${infoTkn}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setAdmin(response.data.data);
      setUsers(response.data.data.User);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, setAdmin, url]);

  const handleViewUserDetails = (user) => {
    setSelectedUser(user);
    setUserDetailsModalOpen(true);
  };

  const handleEditUser = () => {
    setNombre(selectedUser.use_name);
    setApellido(selectedUser.use_lastName);
    setCorreo(selectedUser.use_email);

    setUserDetailsModalOpen(false);
    setEditUserModalOpen(true);
  };

  const handleViewUserMovements = async () => {
    try {
      const response = await axios.get(
        `${url}/Movements/user/${selectedUser.use_id}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setOrdersByUser(response.data);
      setUserDetailsModalOpen(false);
      setUserMovementsModalOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  const toggleModal = () => setModalOpen(!modalOpen);

  const toggleModal2 = () => {
    setModalOpen2(!modalOpen2);
    setSelectedUser(null); // Limpiar el usuario seleccionado al cerrar el modal
    setKycLink(""); // Limpiar el link generado
  };

  const handleSelectUser = (user) => {
    setSelectedUser(user);
  };

  // const handleGenerateLink = () => {
  //   if (selectedUser) {
  //     const link = `https://kyc.example.com/${selectedUser.use_id}`; // Simulamos un enlace único
  //     setGeneratedLink(link);
  //   }
  // };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(kycLink); // Copiar el enlace al portapapeles
  };

  const fetchKycLink = async () => {
    try {
      await axios.put(
        `${url}/users/${selectedUser.use_id}`,
        { use_verif: "P" },
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Verificar si ya existe un kyc_link
      const existingKycLinkResponse = await axios.get(
        `${url}/KycLink/user/${selectedUser.use_id}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
            "Content-Type": "application/json",
          },
        }
      );

      const existingKycLink = existingKycLinkResponse.data;

      // Asegúrate de que la propiedad kyc_link exista
      if (existingKycLink && existingKycLink.kyc_link) {
        console.log(
          "KYC link existente encontrado para el usuario:",
          selectedUser.use_id
        );
        setKycLink(existingKycLink.kyc_link);
      } else {
        // Si no existe un link, obtener uno nuevo
        const response = await fetch(
          `https://kyc-api.amlbot.com/forms/${admin.adm_formKYCToken}/urls`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Token " + apiKey,
            },
          }
        );

        const data = await response.json();
        console.log("Respuesta de la API:", data);

        if (data && data.form_url) {
          const kycData = {
            kyc_link_status: "Pending",
            kyc_link_date: new Date().toISOString(),
            kyc_User_id: selectedUser.use_id,
            kyc_referencedBy: admin.adm_id,
            form_id: data.form_id,
            form_url: data.form_url,
            verification_id: data.verification_id,
            form_token: data.form_token,
            verification_attempts_left: data.verification_attempts_left,
          };

          await axios.post(`${url}/kyclink/create`, kycData, {
            headers: {
              Authorization: `Bearer ${infoTkn}`,
              "Content-Type": "application/json",
            },
          });

          console.log(
            "Nuevo KYC link creado para el usuario:",
            selectedUser.use_id
          );
          
          setKycLink(data.form_url);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      setKycLink("Error al conectar con la API");
    }
  };

  const [kycLink, setKycLink] = useState("");
  const [documentoCaducado, setDocumentoCaducado] = useState(false);
  const [estadoKYC, setEstadoKYC] = useState(""); // Se usará para el filtro de KYC

  const usuariosFiltrados = users.filter((user) => {
    // Filtro por nombre
    const nombreCoincide = user.use_name
      .toLowerCase()
      .includes(busqueda.toLowerCase());

    // Filtro por estado de documento caducado
    const documentoCaducadoCoincide = documentoCaducado
      ? new Date(user.use_dni_expire) < new Date() // Verifica si la fecha de caducidad ha pasado
      : true;

    // Filtro por estado de KYC
    const kycCoincide = estadoKYC ? user.use_verif === estadoKYC : true;

    return nombreCoincide && documentoCaducadoCoincide && kycCoincide;
  });

  // const usuariosPorPagina = 10;

  // const totalPaginas = Math.ceil(usuariosFiltrados.length / usuariosPorPagina);
  // const usuariosPaginados = usuariosFiltrados.slice(
  //   (paginaActual - 1) * usuariosPorPagina,
  //   paginaActual * usuariosPorPagina
  // );

  const obtenerColorKYC = (kycStatus) => {
    switch (kycStatus) {
      case "S":
        return "#28a745"; // Verde
      case "N":
        return "#dc3545"; // Rojo
      case "P":
        return "#ffc107"; // Amarillo
      default:
        return "#888";
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      if (selectedUser) {
        await axios.put(
          `${url}/Users/${selectedUser.use_id}`,
          {
            use_name,
            use_lastName,
            use_email,
          },
          {
            headers: {
              Authorization: `Bearer ${infoTkn}`,
            },
          }
        );
        setSelectedUser(null);
        toggleModal();
        window.location.reload();
      } else {
        await axios.post(
          `${url}/Users`,
          {
            use_name,
            use_lastName,
            use_email,
            use_verif: "N",
            referencedBy: admin.adm_id,
          },
          {
            headers: {
              Authorization: `Bearer ${infoTkn}`,
            },
          }
        );
      }
      setSelectedUser(null);
      toggleModal();
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDataAdmin();
  }, [fetchDataAdmin]);

  return admin ? (
    <div>
      <Adminnavbar />
      <div className="gestion-usuarios">
        {/* Modal de agregar usuario */}
        <Modal
          isOpen={modalOpen}
          toggle={toggleModal}
          className="modal-usuario"
        >
          <ModalHeader toggle={toggleModal} className="modal-header">
            Agregar Usuario
          </ModalHeader>
          <ModalBody className="modal-body">
            <div className="form-group">
              <label>Nombre</label>
              <Input
                type="text"
                value={use_name}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Ingrese el nombre"
                className="modal-input"
              />
            </div>
            <div className="form-group">
              <label>Apellido</label>
              <Input
                type="text"
                value={use_lastName}
                onChange={(e) => setApellido(e.target.value)}
                placeholder="Ingrese el apellido"
                className="modal-input"
              />
            </div>
            <div className="form-group">
              <label>Correo</label>
              <Input
                type="email"
                value={use_email}
                onChange={(e) => setCorreo(e.target.value)}
                placeholder="Ingrese el correo"
                className="modal-input"
              />
            </div>
          </ModalBody>
          <ModalFooter className="modal-footer">
            <Button
              color="primary"
              onClick={handleSubmit}
              className="btn-guardar"
            >
              Guardar
            </Button>{" "}
            <Button
              color="secondary"
              onClick={toggleModal}
              className="btn-cancelar"
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal para Generar Link KYC */}
        <Modal
          isOpen={modalOpen2}
          toggle={toggleModal2}
          className="modal-usuario"
        >
          <ModalHeader toggle={toggleModal2}>
            Seleccionar Usuario para KYC
          </ModalHeader>
          <ModalBody>
            <div className="usuarios-list">
              <table className="tabla-usuarios">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {users
                    .filter(
                      (user) => user.use_verif === "P" || user.use_verif === "N"
                    )
                    .map((user) => (
                      <tr
                        key={user.use_id}
                        onClick={() => handleSelectUser(user)}
                        className={
                          selectedUser && selectedUser.use_id === user.use_id
                            ? "selected"
                            : ""
                        }
                      >
                        <td>{user.use_name}</td>
                        <td>{user.use_email}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {selectedUser && (
              <div className="link-generado">
                <Button className="success" onClick={fetchKycLink}>
                  Generar Link
                </Button>
                {kycLink && (
                  <div className="link-container">
                    <p>
                      Link generado:{" "}
                      <a
                        href={kycLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {kycLink}
                      </a>
                    </p>
                    <button onClick={handleCopyLink}>Copiar Link</button>
                  </div>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleModal2}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        <h1 className="titulo">Gestión de Usuarios</h1>

        <div className="acciones">
          <div className="barra-y-boton">
            <div className="barra-busqueda">
              <input
                type="text"
                placeholder="Buscar usuario..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
              />
            </div>

            <button className="agregar-btn" onClick={toggleModal}>
              <FaPlus className="icono" />
              Agregar Cliente
            </button>

            <button className="generar-btn" onClick={toggleModal2}>
              <FaLink className="icono" />
              Generar Link KYC
            </button>
          </div>

          {/* Filtros */}
          <div className="filtros">
            <div className="filtros-container">
              <div className="filtro-caducidad">
                <label>
                  <input
                    type="checkbox"
                    checked={documentoCaducado}
                    onChange={() => setDocumentoCaducado(!documentoCaducado)}
                  />
                  Documento caducado
                </label>
              </div>
              <div className="filtro-kyc">
                <select
                  value={estadoKYC}
                  onChange={(e) => setEstadoKYC(e.target.value)}
                >
                  <option value="">Estado KYC</option>
                  <option value="S">Verificado</option>
                  <option value="P">En espera</option>
                  <option value="N">Rechazado</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="tabla-container">
          <table className="usuarios-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Email</th>
                <th>DNI</th>
                <th>Caducidad</th>
                <th>País</th>
                <th>Teléfono</th>
                <th>KYC</th>
                <th>Registro</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {usuariosFiltrados.map((user) => (
                <tr
                  key={user.use_id}
                  className={user.use_verif === "S" ? "fila-par" : "fila-impar"}
                >
                  <td>{user.use_id}</td>
                  <td>
                    {user.use_name} {user.use_lastName}
                  </td>
                  <td>{user.use_email}</td>
                  <td>{user.use_dni}</td>
                  <td>{user.use_dni_expire}</td>
                  <td>{user.use_country}</td>
                  <td>{user.use_phone}</td>
                  <td>
                    <div className={`status ${user.use_verif}`}>
                      <span
                        className="icon"
                        style={{
                          backgroundColor: obtenerColorKYC(user.use_verif),
                        }}
                      ></span>{" "}
                    </div>
                  </td>
                  <td>{user.use_createdAt}</td>
                  <td>
                    <Button
                      className="detalles-btn"
                      onClick={() => handleViewUserDetails(user)}
                    >
                      <FaFileAlt className="icono" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <div className="paginacion">
          <button
            disabled={paginaActual === 1}
            onClick={() => setPaginaActual(paginaActual - 1)}
          >
            Anterior
          </button>
          <span>
            Página {paginaActual} de {totalPaginas}
          </span>
          <button
            disabled={paginaActual === totalPaginas}
            onClick={() => setPaginaActual(paginaActual + 1)}
          >
            Siguiente
          </button>
        </div> */}
      </div>

      {/* Detalles del Cliente */}
      <Modal
        isOpen={userDetailsModalOpen}
        toggle={() => setUserDetailsModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setUserDetailsModalOpen(false)}>
          Detalles de {selectedUser?.use_name}
        </ModalHeader>
        <ModalBody>
          <p>
            <strong>Email:</strong> {selectedUser?.use_email}
          </p>
          <p>
            <strong>DNI:</strong> {selectedUser?.use_dni}
          </p>
          <p>
            <strong>Teléfono:</strong> {selectedUser?.use_phone}
          </p>
          <p>
            <strong>País:</strong> {selectedUser?.use_country}
          </p>
          <p>
            <strong>KYC:</strong> {selectedUser?.use_verif}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="warning" onClick={handleEditUser}>
            Editar Usuario
          </Button>
          <Button color="primary" onClick={handleViewUserMovements}>
            Ver Movimientos
          </Button>
        </ModalFooter>
      </Modal>

      {/* Editar Usuario */}
      <Modal
        isOpen={editUserModalOpen}
        toggle={() => setEditUserModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setEditUserModalOpen(false)}>
          Editar Usuario
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Nombre</Label>
            <Input
              type="text"
              defaultValue={use_name}
              onChange={(e) => setNombre(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Apellido</Label>
            <Input
              type="text"
              defaultValue={use_lastName}
              onChange={(e) => setApellido(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Email</Label>
            <Input
              type="email"
              defaultValue={use_email}
              onChange={(e) => setCorreo(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setEditUserModalOpen(false)}>
            Cancelar
          </Button>
          <Button color="success" onClick={handleSubmit}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Movimientos del Usuario */}
      <Modal
        isOpen={userMovementsModalOpen}
        toggle={() => setUserMovementsModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setUserMovementsModalOpen(false)}>
          Movimientos de {selectedUser?.use_name}
        </ModalHeader>
        <ModalBody>
          <Table className="usuarios-table">
            <thead>
              <tr>
                <th>Monto (€)</th>
                <th>Moneda</th>
                <th>Monto Calculado</th>
                <th>Estado</th>
                <th>Fecha</th>
              </tr>
            </thead>
            <tbody>
              {ordersByUser?.map((movement, index) => (
                <tr key={index.mov_id}>
                  <td>€ {movement.mov_amount}</td>
                  <td>{movement.mov_conversionType}</td>
                  <td>{movement.mov_paymentAmount}</td>
                  <td>
                    {movement.mov_status === "P"
                      ? "Pendiente"
                      : movement.mov_status === "R"
                      ? "Rechazada"
                      : "Aprobada"}
                  </td>
                  <td>{movement.mov_date}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setUserMovementsModalOpen(false)}
          >
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  ) : (
    <NotFound />
  );
}

export { GestionUsuarios };